import React, { Component, Fragment } from "react";
import ProcessorComparisonResult from "../../../../models/ProcessorComparisonResult";
import LoadingCard from "../../../LoadingCard";
import MailroomDurableFunctionInstanceList from "../../../mailroom/MailroomDurableFunctionInstanceList";
import ProcessorDiffViewer from "../../../ProcessorDiffViewer";
import PageTitle from "../../../PageTitle";
import {ICDBPageProps} from "../../../../utils/ICDBPageProps";

interface ProcessorComparisonPageProps extends ICDBPageProps
{
    instanceIdA: string;
    instanceIdB: string;
}

interface ProcessorComparisonPageState
{
    loading: boolean;
    comparisonResult?: ProcessorComparisonResult
}

export default class ProcessorComparisonPage extends Component<ProcessorComparisonPageProps, ProcessorComparisonPageState> {

    constructor(props: ProcessorComparisonPageProps) {
        super(props);

        this.state = {
            loading: false,
            comparisonResult: undefined
        };
    }

    async componentDidUpdate(prevProps: Readonly<ProcessorComparisonPageProps>, prevState: Readonly<ProcessorComparisonPageState>, snapshot?: any): Promise<void> {
        
        if(this.props.instanceIdA !== prevProps.instanceIdA || this.props.instanceIdB !== prevProps.instanceIdB)
        {
            await this.load();
        }
    }

    async componentDidMount() {
        await this.load();
    }
    
    private load = async () => {

        if(!this.props.instanceIdA || !this.props.instanceIdB)
        {
            return;
        }

        this.setState({
            loading: true
        });

        try
        {
            const result = await this.props.apiService.compareProcessorOutputs(this.props.instanceIdA, this.props.instanceIdB);
            this.setState({
                comparisonResult: result
            });
        }
        catch (e)
        {
            this.props.messageBar.error(`Comparison request failed : ${e}`);
        }

        this.setState({
            loading: false
        });
    }
    
    
    render() {
        
        if(this.state.loading)
        {
            return <LoadingCard/>;
        }
        
        if(!this.state.comparisonResult)
        {
            return null;
        }
        
        return (
            <Fragment>
                <PageTitle title="Processor Comparison" /> 
                <MailroomDurableFunctionInstanceList title={"Instances"} columns={MailroomDurableFunctionInstanceList.processorColumns} additionalCellForColumn={MailroomDurableFunctionInstanceList.processorAdditionalCellForColumn} enableRowLinks={false} instances={[this.state.comparisonResult!.firstInstance!, this.state.comparisonResult!.secondInstance!]} />
                <ProcessorDiffViewer result={this.state.comparisonResult!}/>
            </Fragment>
        );
    }
}